export const getBackUrl = (url: string) => {
  const currentUrl = window.Alfresco.util.parseURL(window.location.href);
  const backUrl = document.referrer ? window.Alfresco.util.parseURL(document.referrer) : null;
  const returnTo = currentUrl.queryParams && currentUrl.queryParams.returnTo ? currentUrl.queryParams.returnTo : '';

  if (backUrl && currentUrl.hostname === backUrl.hostname && currentUrl.pathname !== backUrl.pathname) {
    return `${document.referrer}#${returnTo}`;
  }

  return `${url}#${returnTo}`;
};
